import { ComposeViewState } from '../store/schema/ComposeViewState';

export default function getRecipientWellViewStates(viewState: ComposeViewState) {
    let viewStates = [];
    // the to recipient well should only be undefined in tests
    if (viewState.toRecipientWell) {
        viewStates.push(viewState.toRecipientWell);
    }
    if (viewState.ccRecipientWell) {
        viewStates.push(viewState.ccRecipientWell);
    }
    if (viewState.bccRecipientWell) {
        viewStates.push(viewState.bccRecipientWell);
    }
    return viewStates;
}
